'use strict';

module.exports = /* @ngInject */ ["$q", "authApiFactory", "eikonSsoService", "$log", function ($q,
                                           authApiFactory,
                                           eikonSsoService,
                                           $log) {
  var that = this;
  var getEikonLightAttributesPromise;
  var DEFAULT_SXS_PORT = 9011;

  that.getEikonLightAttributes = function (sxsPort) {
    if (!getEikonLightAttributesPromise) {
      getEikonLightAttributesPromise = authApiFactory.create().then(function (authApi) {
        return eikonSsoService.getEikonToken().then(function (eikonToken) {
          return authApi
            .one('eikonlight')
            .one('attributes')
            .withHttpConfig({ignoreAuthModule: true})
            .get({sxsPort: sxsPort || DEFAULT_SXS_PORT}, {'Eikon-Token': eikonToken})
            .then(function (eikonLightAttributes) {
              $log.info('eikonLightAttributes ' + JSON.stringify(eikonLightAttributes));
              return eikonLightAttributes;
          });
        });
      });
    }
    return getEikonLightAttributesPromise;
  };
}];



//////////////////
// WEBPACK FOOTER
// /app/~/redi-idp-web-lib/dist/business/eikonAttributeRepository.js
// module id = 118
// module chunks = 0